import { render, staticRenderFns } from "./screen-actions-menu.vue?vue&type=template&id=b7fd52e6&scoped=true"
import script from "./screen-actions-menu.vue?vue&type=script&lang=js"
export * from "./screen-actions-menu.vue?vue&type=script&lang=js"
import style0 from "./screen-actions-menu.vue?vue&type=style&index=0&id=b7fd52e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fd52e6",
  null
  
)

export default component.exports